import { useMutation, useQueryClient } from '@tanstack/react-query';
import { batchMarkPotsPaid } from '../api/potsApi';

interface MarkPotPaidParams {
  potPeriodId: string;
  potId: string;
}

/**
 * Mutation hook for marking a single pot as paid.
 * Wraps the batch mark paid API for single pot operations.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useMarkPotPaid() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ potPeriodId, potId }: MarkPotPaidParams) => {
      return await batchMarkPotsPaid({
        potPeriodId,
        potIds: [potId],
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pots'] });
      queryClient.invalidateQueries({ queryKey: ['potDetails'] });
      queryClient.invalidateQueries({ queryKey: ['payments'] });
    },
  });
}
